import setCommonScripts from './routes/common';
import setBlocksScripts from './routes/blocks';

import Article from './modules/components/article';

import setAuthScripts from './routes/auth';
import setDashboardScripts from './routes/dashboard';
import setProfileScripts from './routes/profile';

import setProjectsScripts from './routes/projects';
import setDonationScripts from './routes/donation';
import setCreationScripts from './routes/creation';

import setJobsScripts from './routes/jobs';
import setProposalScripts from './routes/proposal';
import setPaymentScripts from './routes/payment';

import setSearchScripts from './routes/search';

import Selection from './modules/components/selection';

import '../scss/styles.scss';

document.addEventListener('DOMContentLoaded', () => {
  setCommonScripts();
  setBlocksScripts();

  setAuthScripts();
  setDashboardScripts();
  setProfileScripts();

  setProjectsScripts();
  setDonationScripts();
  setCreationScripts();

  setJobsScripts();
  setProposalScripts();
  setPaymentScripts();

  // Search

  setSearchScripts();

  // Article

  if (document.body.classList.contains('template-template-article')) new Article('.site-article');

  // Selection

  new Selection('.site-field.selection');
});
